"use client";

import FaqSection from "@/components/sections/products/shared/faq";
import RelatedContent from "@/components/sections/tools/shared/related-content";
import { EXTENSION_CONFIGS, EXTENSION_RELATED_CONTENT } from "./data";
import type { Browser } from "./types";
import {
  ExtensionHero,
  IntroBlock,
  FeatureGrid,
  ShowcaseTabs,
  Steps,
  Permissions,
  ExtensionCta,
} from "./parts";

interface Props {
  browser: Browser;
}

export default function ExtensionLanding({ browser }: Props) {
  const config = EXTENSION_CONFIGS[browser];
  const relatedContent = EXTENSION_RELATED_CONTENT[browser];

  return (
    /* No overflow clip here: the banded sections use `.full-bleed`, whose
       negative margins have to escape the shell's max-w-7xl frame to reach the
       viewport edges. html/body already carry overflow-x: clip, so 50vw stays
       scroll-safe — the hero section keeps its own clip for the glow. */
    <main id="main-content" tabIndex={-1} className="relative">
      <ExtensionHero config={config} />
      <IntroBlock config={config} />
      <FeatureGrid config={config} />
      <ShowcaseTabs config={config} />
      <Steps config={config} />
      <Permissions config={config} />
      <RelatedContent
        fromPage={`tools/${browser}-extension`}
        blogLinks={relatedContent.blogLinks}
        useCaseLinks={relatedContent.useCaseLinks}
      />
      <FaqSection
        faqs={config.faqs}
        description={config.faqDescription}
        headingId="ext-faq-heading"
      />
      <ExtensionCta config={config} />
    </main>
  );
}
